<div class="upload-invoice-milestone">
  <div class="upload-invoice-milestone__left">
    <div class="upload-invoice-milestone__icon-wrapper">
      <img
        class="upload-invoice-milestone__icon"
        [src]="'assets/icons/outline-document-upload.svg'"
        alt=""
        aria-hidden="true"
      />
    </div>
    <span class="upload-invoice-milestone__text">Subir factura</span>
  </div>

  <div class="upload-invoice-milestone__btn-actions">
    <button class="upload-invoice-milestone__btn" type="button" (click)="onIniciarClick()">Iniciar</button>
  </div>
</div>
